<template>
  <!-- 今日课堂 -->
  <div class="today-class-container">
    <div class="title">
      <span></span>
      <span>今日课堂</span>
    </div>
    <div class="function-button">
      <div class="select-option">
        <el-select v-model="dataForm.gradeId" placeholder="请选择" :popper-append-to-body="false">
          <el-option key="-1,-1" label="全部年级" value="-1,-1"/>
          <el-option
              v-for="item in gradeList"
              :key="item.gradeId"
              :label="item.gradeName"
              :value="item.gradeId"/>
        </el-select>
        <el-select v-model="dataForm.subjectId" placeholder="请选择" :popper-append-to-body="false">
          <el-option key="-1" label="全部学科" value="-1"/>
          <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.subject_name"
              :value="item.id"/>
        </el-select>
      </div>
      <div class="setting-button">
        <div class="setting-btn" @click="settingCurriculum">
          <span>设置课表</span>
        </div>
        <div class="setting-date">
          <el-popover placement="top" ref="datePopoverRef" width="160" v-model="popoverVisible"
                      popper-class="custom-popover">
            <el-date-picker ref="datePickerRef" v-model="dataForm.selectDate" type="date" placeholder="选择日期"
                            value-format="yyyy/MM/dd" :clearable="false"
                            format="yyyy/MM/dd" @change="popoverVisible = false" size="small"
                            :picker-options="pickerOptions"
                            :append-to-body="zoom <= 1" :popper-class="zoom >1 ?'custom-date-picker':''"/>
            <img slot="reference" src="../../../assets/images/nanjingdataboard/switch.png" alt="">
          </el-popover>
          <span>日期：{{ dataForm.selectDate }}</span>
        </div>
      </div>
    </div>
    <div class="container">
      <el-table :data="tableList" style="width: 100%" empty-text=" " element-loading-background="rgba(0, 0, 0, 0)"
                element-loading-text="数据正在加载中" element-loading-spinner="el-icon-loading"
                :header-cell-style="{
             background: 'rgba(76, 118, 186, 0.2)',
             color: '#8BA4E7',
              fontsize:'16px',
              fontWeight:'bold',
              fontFamily:'Microsoft YaHei',
              }" class="custom-table" @row-click="handleRowClick">
        <template #empty>
          <div style="font-size: 30px" v-if="classCourseState === 0">
            <el-link :underline="false" style="font-size: 30px;color: #fff">暂无课程，请先</el-link>
            <el-link :underline="true" type="success" style="font-size: 30px" @click="settingCurriculum">设置课表
            </el-link>
          </div>
        </template>
        <el-table-column prop="classroomName" label="教室" align="center"/>
        <el-table-column label="上课时间" align="center" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.startTime }}-{{ scope.row.endTime }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="teaName" label="老师" align="center"/>
        <el-table-column prop="className" label="班级" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.className"> {{
                scope.row.className.includes(scope.row.gradeName) ? scope.row.className : scope.row.gradeName + scope.row.className
              }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="subjectName" label="学科" align="center"/>
        <el-table-column prop="whiteboardNum" label="电子白板" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.whiteboardNum > 0">{{ scope.row.whiteboardNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="textbookNum" label="电子教材" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.textbookNum > 0">{{ scope.row.textbookNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="coursewareNum" label="电子课件" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.coursewareNum > 0">{{ scope.row.coursewareNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="commentaryNum" label="作业讲评" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.commentaryNum > 0">{{ scope.row.commentaryNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="classroomInteractionNum" label="教学互动" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.classroomInteractionNum > 0">{{ scope.row.classroomInteractionNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="praiseNum" label="课堂点评" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.praiseNum > 0">{{ scope.row.praiseNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="classroomActivityNum" label="课堂活动" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.classroomActivityNum > 0">{{ scope.row.classroomActivityNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="screenInteractionNum" label="多屏互动" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.screenInteractionNum > 0">{{ scope.row.screenInteractionNum }}</span>
          </template>
        </el-table-column>
        <el-table-column label="上课状态" align="left" width="150">
          <template slot-scope="scope">
            <div class="handle-div" v-if="checkClassTime(scope.row) === 0" title="未上课">
              <span>未上课</span>
            </div>
            <div class="handle-div" v-if="checkClassTime(scope.row) === 1" title="上课中"
                 @click="handleClick(scope.row)">
              <img src="../../../assets/images/nanjingdataboard/attend-class.gif" alt="">
              <span>上课中</span>
              <span v-if="activeRow === JSON.stringify(scope.row)"> >> </span>
            </div>
            <div class="handle-div" v-if="checkClassTime(scope.row) === -1" title="已结束"
                 @click="handleClick(scope.row)">
              <span>已结束</span>
              <span v-if="activeRow === JSON.stringify(scope.row)"> >> </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <CurriculumSetting ref="settingCurriculumRef" :school-id="schoolId" :bind-class-list="bindClassList"
                       :classroom-list="classroomList" @refresh-classroom-list="getClassroomList"
                       @refresh-class-course-state="getClassCourseState" :zoom="zoom"/>
  </div>
</template>
<script>
import CurriculumSetting from "../curriculumSetting.vue";
import {
  getClassCourseTableStateApi,
  getClassroomAnalysisDincDataApi, getClassRoomListApi,
  getScreenBindClassBySchoolIdApi
} from "../../../service/bigDataApi";

export default {
  name: "today-class",
  components: {CurriculumSetting},
  props: {
    // 年级列表
    gradeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 学科列表
    subjectList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 学校Id
    schoolId: {
      type: String,
      default: '0'
    },
    zoom: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      dataForm: {
        gradeId: '-1,-1',
        subjectId: '-1',
        selectDate: this.$moment(new Date()).format('YYYY/MM/DD'),
      },
      // 绑定班级列表
      bindClassList: [],
      // 弹出框
      popoverVisible: false,
      // 数据列表
      tableList: [],
      // 激活的行
      activeRow: '',
      // 课表设置状态
      classCourseState: 0,
      // 定时刷新
      timer: null,
      // 教室列表
      classroomList: [],
      // 禁止选择今日之后的日期
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      }
    }
  },
  watch: {
    dataForm: {
      deep: true,
      handler(value) {
        if (value) {
          this.$nextTick(() => {
            this.findClassroomAnalysisData()
          })
        }
      }
    },
    popoverVisible: {
      deep: true,
      handler(value) {
        if (value) {
          const ratio = window.devicePixelRatio
          if (ratio > 1) {
            const popoverRef = this.$refs.datePopoverRef
            let timer = setTimeout(() => {
              // 找到气泡元素
              const {popperElm} = popoverRef
              let left = popperElm.style.left.replace('px', '') * ratio + 35 + 'px'
              let top = popperElm.style.top.replace('px', '') * ratio + 20 + 'px'
              popoverRef.popperElm.style.left = left
              popoverRef.popperElm.style.top = top
              clearTimeout(timer)
            }, 50)
          }
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getClassCourseState()
      this.getClassroomList()
      this.findBindScreenClassList()
      this.findClassroomAnalysisData()
      this.startInterval()
    })
  },
  beforeDestroy() {
    if (this.timer) {
      this.clearInterval()
    }
  },
  methods: {
    /**
     * 设置课表
     */
    settingCurriculum() {
      this.$nextTick(() => {
        this.$refs.settingCurriculumRef.showDialog()
      })
    },

    // 获取教室绑定班级列表
    async getClassroomList() {
      let _this = this;
      let params = {
        schoolId: this.schoolId === "0" ? "" : this.schoolId,
      }
      await getClassRoomListApi(params).then((res) => {
        this.classroomList = res;
      }).catch(function (error) {
        _this.$message.error(error.message);
      })
    },

    // 获取绑定班级列表
    async findBindScreenClassList() {
      let _this = this;
      let params = {
        schoolId: this.schoolId === "0" ? "" : this.schoolId,
        gradeId: '-1,-1',
      }
      await getScreenBindClassBySchoolIdApi(params).then((data) => {
        _this.bindClassList = data.map((item) => {
          item.disabled = false
          return item
        });
      }).catch(function (error) {
        _this.$message.error(error.message);
      });
    },

    // 获取数据
    async findClassroomAnalysisData() {
      let _this = this;
      let params = {
        schoolId: this.schoolId === "0" ? "" : this.schoolId,
        gradeId: this.dataForm.gradeId,
        subjectId: this.dataForm.subjectId,
        date: this.dataForm.selectDate ? this.dataForm.selectDate : _this.$moment(new Date()).format('YYYY/MM/DD'),
      }
      await getClassroomAnalysisDincDataApi(params).then((data) => {
        this.tableList = data;
      }).catch(function (error) {
        _this.$message.error(error.message);
      })
    },

    // 获取课表状态
    getClassCourseState() {
      let _this = this;
      let params = {
        schoolId: this.schoolId === "0" ? "" : this.schoolId,
      }
      getClassCourseTableStateApi(params).then((data) => {
        this.classCourseState = data
      }).catch(function (error) {
        _this.$message.error(error.message);
      })
    },

    // 检测上课时间
    checkClassTime(row) {
      let now = new Date();
      let nowTime = this.$moment(now).format('YYYY-MM-DD HH:mm:ss');
      let startTime = row.date + ' ' + row.startTime + ':00';
      let endTime = row.date + ' ' + row.endTime + ':00';
      if (nowTime >= startTime && nowTime <= endTime) {
        return 1
      } else if (nowTime < startTime) {
        return 0
      } else if (nowTime > endTime) {
        return -1
      }
    },

    // 点击行显示数据
    handleRowClick(row, column, event) {
      this.handleClick(row)
    },

    // 点击显示数据
    handleClick(row) {
      this.activeRow = JSON.stringify(row)
      let data = {
        roomClassId: row.roomClassId,
        startTime: this.dataForm.selectDate.replaceAll('/', '-') + ' ' + row.startTime + ':00',
        endTime: this.dataForm.selectDate.replaceAll('/', '-') + ' ' + row.endTime + ':00',
      }
      this.$emit('handle-classroom-click', data)
    },

    // 开始定时刷新
    startInterval() {
      this.timer = setInterval(() => {
        this.findClassroomAnalysisData()
      }, 5000)
    },

    // 停止刷新
    clearInterval() {
      clearInterval(this.timer)
      this.timer = null
    },
  }
}

</script>

<style scoped lang="scss">
.today-class-container {
  background-image: url("../../../assets/images/nanjingdataboard/bg-4.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;

  .title {
    position: relative;
    width: 100%;
    top: 35px;
    height: 30px;
    font-family: Microsoft YaHei, serif;
    font-weight: bold;
    font-size: 20px;
    color: #FFFFFF;
    text-shadow: 0 3px 7px rgba(0, 0, 0, 0.35);
    text-align: left;
    //background: linear-gradient(0deg, rgba(77, 190, 255, 0.62) 0%, rgba(77, 190, 255, 0) 100%);
    //-webkit-background-clip: text;
    //-webkit-text-fill-color: transparent;

    span:nth-of-type(1) {
      display: inline-block;
      transform: translateY(2px);
      width: 8px;
      height: 18px;
      background: #06D6F8;
      border-radius: 4px;
      margin-left: 20px;
    }

    span:nth-of-type(2) {
      width: 120px;
      height: 20px;
      font-family: Microsoft YaHei;
      margin-left: 10px;
      font-weight: bold;
      font-size: 20px;
      color: #FFFFFF;
      text-shadow: 0 3px 7px rgba(0, 0, 0, 0.35);
      //background: linear-gradient(0deg, rgba(77, 190, 255, 0.62) 0%, rgba(77, 190, 255, 0) 100%);
      //-webkit-background-clip: text;
      //-webkit-text-fill-color: transparent;
    }
  }

  .function-button {
    position: relative;
    width: calc(100% - 135px);
    left: 135px;
    top: 6px;
    height: 30px;
    z-index: 999;
    text-align: left;
    color: #8BA4E7;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .select-option {
      :deep(.el-select) {
        width: 120px;
        color: #8BA4E7;
        margin-right: 10px;

        .el-select__caret {
          line-height: 30px;
          color: #8BA4E7;
        }

        .el-input__inner {
          height: 29px !important;
          background: rgba(13, 33, 94, 0.43);
          border: 1px solid #4C76BA;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 16px;
          border-radius: 2px;
          color: #8BA4E7;
          line-height: 30px;
        }

        //.el-input__placeholder{
        //  color: red;
        //}
      }
    }

    .setting-button {
      position: relative;
      height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 40px;

      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #0BD7F8;

      .setting-btn {
        margin-right: 20px;
        cursor: pointer;
      }

      .setting-date {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

        :deep(.el-popover) {
          padding: 0;
        }

        .el-input {
          width: 158px;
          border: unset;

          .el-input__inner {
            border: none;
          }
        }

        .el-input:hover {
          border: unset;
        }

        :deep(.el-popover__reference-wrapper) {
          height: 24px !important;
        }

        img {
          width: 14px;
          height: 14px;
          cursor: pointer;
          margin-left: 5px;
          margin-right: 5px;
        }
      }
    }
  }


  .container {
    position: relative;
    width: 100%;
    height: calc(100% - 70px);
    top: 10px;
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 20px;

    :deep(.el-table) {
      background-color: transparent !important;
      margin: 0;
      height: 100%;

      .el-table__body-wrapper {
        height: calc(100% - 70px);
        overflow-y: auto;
      }
    }

    :deep(.el-table::before) {
      background-color: transparent !important;
    }

    :deep(.el-table .el-table__header-wrapper) {
      background-color: rgba(76, 118, 186, 0.2);
      border-radius: 10px 10px 2px 2px;
      color: #8BA4E7;
    }

    :deep(.el-table tr) {
      background-color: rgba(76, 118, 186, 0);
    }

    :deep(.el-table th) {
      background-color: rgba(76, 118, 186, 0);
      color: #8BA4E7;
    }

    :deep(.el-table th.el-table__cell.is-leaf) {
      border-bottom: unset !important;
    }

    :deep(.el-table td.el-table__cell) {
      border-bottom: unset !important;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #C7D5F2;
    }

    // 空数据样式
    :deep(.el-table__empty-block) {
      //border-top: 1px solid #626F96;
    }

    :deep(.el-table .el-table__body-wrapper) {
      margin-top: 20px;
      border-top: unset;
      //border-right: 1px solid #626F96;
      //border-left: 1px solid #626F96;
      //border-bottom: 1px solid #626F96;
    }

    :deep(.el-table .el-table__body ) {
      tr:hover > td {
        background-color: rgba(76, 118, 186, 0.2) !important;
      }
    }

    .handle-div {
      position: relative;
      height: 30px;
      display: flex;
      justify-content: left;
      align-items: center;
      cursor: pointer;
      box-sizing: border-box;

      img {
        width: 25px;
        height: 25px;
        margin-right: 10px;
      }

      span:nth-of-type(2) {
        margin-left: 10px;
      }
    }
  }
}

:deep(.el-select-dropdown) {
  background: rgba(13, 33, 94, 1);
  border: 1px solid #4C76BA;
  color: #8BA4E7;

  .el-select-dropdown__item {
    color: #8BA4E7;
  }

  .el-select-dropdown__empty {
    color: #8BA4E7;
  }

  .popper__arrow {
    border-bottom-color: #4C76BA !important;
  }

  .popper__arrow::after {
    border-bottom-color: #4C76BA !important;
  }

  .el-select-dropdown__item.hover {
    background-color: rgba(76, 118, 186, 0.2);
  }
}

</style>
<style lang="scss">
.el-popover.custom-popover {
  padding: 0;

  .el-date-editor.el-input {
    width: 158px;
    border: unset;
  }

  .custom-date-picker {
    top: 30px !important;
  }
}
</style>
